import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ymcaSsoAction } from './YmcaSsoAction';
import { ActionType } from '../../core/redux/actionType';
import { Redirect, useLocation } from 'react-router-dom';
import { parseQueryToKeyedStrings } from '../../navigation/module';
import { useRoutes } from '../../navigation/routes';
import { useError, useLoading } from '../../core/api/hooks';
import ProjectModal from '../../project/ProjectModal';
import { useAppState } from '../../core/redux/hooks';
import { useMount } from '../../core/hooks/useMount';
import { strictEquals } from '../../language/module';
import { UserInfo } from '../authState';
import { AppState } from '../../core/redux/appState';


type Props = {
  className?: string;
};

type queryProps = {
  ticket?: string;
  projectid?: string;
  returnURL?: string;
};


const YmcaSsoPage: React.FC<Props> = props => {
  const dispatch = useDispatch();

  const location = useLocation();
  const queryObj = parseQueryToKeyedStrings<queryProps>(location.search);

  const loginError  = !!useError(ActionType.YmcaSsoRequest);
  const isLoggingIn = useLoading(ActionType.YmcaSsoRequest);

  const userInfo = useSelector<AppState, UserInfo | undefined>(state => state.auth.currentUser, strictEquals);

  const projectId     = queryObj.projectid ?? queryObj.returnURL;
  const participantId = useAppState(state => state.auth.currentUser?.personId ?? 0);

  const routes = useRoutes(`${userInfo?.personId ?? participantId}`, projectId);

  useMount(() => { dispatch(ymcaSsoAction(queryObj.ticket, queryObj.projectid, queryObj.returnURL)); });

  return (
    <div>
      {
        isLoggingIn && (
          <div>Redirecting...</div>
        )
      }
      {
        !queryObj.ticket && (
          <Redirect
            to={{
              pathname: routes.YmcaLogin,
              search:   location.search,
            }}
          />
        )
      }
      {
        loginError && (
          <Redirect to={routes.Login} />
        )
      }
      {
        !!userInfo && userInfo.authenticated && (
          projectId
            ? <Redirect to={routes.Project} />
            : <ProjectModal />
        )
      }
    </div>
  );
};

export default YmcaSsoPage;
